import React, { useContext, useState } from 'react'
import { useForm } from 'react-hook-form';
import { baseUrl, path, TOKEN_KEY } from '../../constants';
import axios from 'axios'
import { appContext } from '../../Context/appProvider';
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner'

export default function Signin() {
    const {setToken} = useContext(appContext)
    const navigate = useNavigate()
    const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm();
    const [error, setError] = useState(null)

    const onSubmit = data => {
        return new Promise((resolve, reject) => {
          axios(baseUrl + path.signin, {
            method: 'post',
            data
          }).then(response => {
            resolve(true)
            if(response.data.success){
              localStorage.setItem(TOKEN_KEY, response.data.token)
              setToken(response.data.token)
              resolve(true)
            //   navigate('/')
            } else setError(response.data.message)
          })
          .catch(e => {
            resolve(true)
            setError('Network Error')
          })
        })
    }
    return (
    <div className='w-screen h-screen flex items-center justify-center bg-lightGrey'>
        <div className='bg-white rounded-md shadow-md flex flex-col p-5 w-[400px] items-center gap-5'>
            <p className='text-[16px] text-black font-bold'>Admin Login</p>
            {error && (
                <p className='bg-[#f946464f] animate-bounce-slow ease-linear text-[#f94646] text-[15px] font-bold px-10 py-2 rounded-sm'>
                {error}
                </p>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-3 w-full'>
                <input {...register('email')} placeholder='Email' type='email' className='border-[1px] border-solid border-[#00000040] p-2' />
                <input {...register('password')} placeholder='Password' type='password' className='border-[1px] border-solid border-[#00000040] p-2' />
                <button type='submit' className='bg-main text-white text-[14px] p-2 flex items-center justify-center'>
                {isSubmitting ? (
                    <Oval
                        visible={true}
                        height="21"
                        width="21"
                        color="#ffffff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                    />
                ) : 'Sign In'}
                </button>
            </form>
        </div>
    </div>
    )
}
